import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import MDInput from "components/MDInput";
import {
  locChuoiNhap,
  locThanhSoThuan,
  locThanhChuoiHienThi,
  soThanhChuoiHienThi,
  chuoiHienThiThanhSo,
} from "lib/dinhDangSo";

// Ô nhập số có dấu chấm ngăn hàng nghìn tự động khi gõ (gõ "10000" hiện
// "10.000"). Giá trị đưa ra ngoài qua onChange vẫn là chuỗi số thuần (vd
// "10000", "12.5") giống hệt MDInput type="number" cũ, nên chỗ gọi không
// phải đổi logic Number(...)/validate đang có — chỉ đổi component + bỏ prop
// type/inputProps min-step (không còn ý nghĩa với input kiểu text).
function MDInputSo({ value, onChange, thapPhan, inputProps, ...rest }) {
  const [chuoiHienThi, setChuoiHienThi] = useState(() => soThanhChuoiHienThi(value));

  useEffect(() => {
    const soHienTai = chuoiHienThiThanhSo(chuoiHienThi);
    const soMoi = value === "" || value === null || value === undefined ? "" : Number(value);
    if (soHienTai !== soMoi) setChuoiHienThi(soThanhChuoiHienThi(value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  function xuLyThayDoi(e) {
    const loc = locChuoiNhap(e.target.value, !!thapPhan);
    setChuoiHienThi(locThanhChuoiHienThi(loc));
    onChange(locThanhSoThuan(loc));
  }

  return (
    <MDInput
      type="text"
      value={chuoiHienThi}
      onChange={xuLyThayDoi}
      inputProps={{ inputMode: thapPhan ? "decimal" : "numeric", ...inputProps }}
      {...rest}
    />
  );
}

MDInputSo.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  thapPhan: PropTypes.bool,
  inputProps: PropTypes.object,
};

MDInputSo.defaultProps = {
  value: "",
  thapPhan: false,
  inputProps: undefined,
};

export default MDInputSo;
